const _ = require('lodash');
const fillServerErrors = require('../../../../common/components/servererrorfiller');
const guestUserCreatedMapper = require('../atmmapper/guest-user-created-mapper');
const rsaInteractionMapper = require('../../../../checkout/components/delivery/atmmapper/rsa-interactions-mapper');

function GuestSignupDeliveryDirective(AddressService, BwsNotificationService, ServerErrorFiller, $rootScope, $templateCache, currentUserService, storePickerService, checkoutService, ageCalculatorService, atm, shopperService, deliveryService) {
    return {
        restrict: 'E',
        template: require('./guest-signup-delivery-template.html'),
        transclude: true,
        scope: {
            editMode: '=?',
            nextStep: '&?',
            cancelStep: '&',
            isGuestCheckout: '=?',
            hideCancelBtn: '=?',
            isAddingBillingAddress: '=?',
            isAddingNewAddressInCheckout: '=?',
            isAddingPrimaryAddress: '=?'
        },
        link(scope) {
        scope.addressService = AddressService;
        scope.currentUser = currentUserService.currentUser;
        scope.guestDetails = {};
        scope.savedAddress = {};
        scope.isEligible = false;
        scope.serverErrors = {};
        scope.shopper = shopperService;
        scope.delivery = deliveryService;
        scope.storePickerService = storePickerService;
        scope.isAddingNewAddress = { mode: true };
        scope.addressStoreLocatorSearch = {};
        scope.isRecipient = true;
        scope.isGuestTheRecipient = true;
        if (!_.isUndefined(scope.isAddingBillingAddress)) {
            scope.isForBilling = scope.isAddingBillingAddress.mode;
        }

        if (!_.isUndefined(scope.isAddingNewAddressInCheckout) && scope.isAddingNewAddressInCheckout.mode === true) {
            scope.isForBilling = true;
        }

        //In case of guest signup in checkout, check they are over 18
        scope.checkEligibility = function () {
            if (scope.addressForm.addressFormDOB.$valid && ageCalculatorService.calculate(scope.modifiedAddress.DateOfBirth) >= 18) {
                scope.isEligible = true;
            } else {
                scope.isEligible = false;
            }
        };

        function isValidAddress(address) {
            return (address !== undefined && address.AddressId !== '');
        }

        function buildAddress() {
            const dto = {
                FirstName: scope.shopper.FirstName || '',
                LastName: scope.shopper.LastName || '',
                CompanyName: '',
                ContactNumber: scope.shopper.Phone || '',
                DateOfBirth: scope.shopper.DateOfBirthInput || '',
                AddressMode: 'auto',
                DeliveryMethod: storePickerService.fulfilmentInfo.FulfilmentMethod === 'Delivery' ? 'Delivered' : 'PickedUp',
                IsForBilling: true,
                Automatic: {
                    AddressId: '',
                    AddressLabel: '',
                    PostCode: '',
                    State: ''
                },
                Manual: {
                    Street1: scope.savedAddress !== undefined ? scope.savedAddress.Street1 : '',
                    Street2: scope.savedAddress !== undefined ? scope.savedAddress.Street2 : '',
                    PostCode: scope.savedAddress !== undefined ? scope.savedAddress.PostalCode : '',
                    State: scope.savedAddress !== undefined ? scope.savedAddress.State : ''
                }
            };

            return dto;
        }

        const initialize = function () {
            scope.addressService = AddressService; //TODO: This should never be exposed on the scope!
            scope.showEditManualLink = true;
            scope.suburbs = [];
            scope.fulfilmentInfo = storePickerService.fulfilmentInfo;
            scope.addressItemTemplate = 'address-item-template.html';
            $templateCache.put(scope.addressItemTemplate, require('./address-item-template.html'));
        };

        scope.toggleIsBillingAddress = function () {
            scope.isForBilling = !scope.isForBilling;
        };
        scope.toggleRecipientOptions = function () {
            scope.isGuestTheRecipient = !scope.isGuestTheRecipient;
            atm.push({
                linkType: 'checkout legislation interactions',
                linkName: `web:checkout:i am the delivery recipient: ${scope.isGuestTheRecipient ? 'checked' : 'unchecked'}`
            }, rsaInteractionMapper);
            scope.delivery.isGuestTheRecipient(scope.isGuestTheRecipient, false);
        };
        const resetAddressForm = function () {
            scope.modifiedAddress = buildAddress();
            scope.addressForm.$setPristine();
            scope.addressForm.$setUntouched();
            ServerErrorFiller.clearForm(scope.addressForm, scope);
        };

        const updateAddress = function () {
            $rootScope.$broadcast('myaccount:updateAddress');
            $rootScope.$broadcast('address-update');
            $rootScope.$broadcast('address:newAddressAdded');
        };

        const guardAgainstNull = function (address, func) {
            return (address === undefined || address === null) ? func() : address;
        };

        const isManualAddress = () => {
            scope.modifiedAddress = guardAgainstNull(scope.modifiedAddress, buildAddress);
            return scope.modifiedAddress.AddressMode === 'manual' || scope.modifiedAddress.TypeOfAddress === 'manual';
        };

        const isAutoAddress = () => {
            scope.modifiedAddress = guardAgainstNull(scope.modifiedAddress, buildAddress);
            return scope.modifiedAddress.AddressMode === 'auto' || scope.modifiedAddress.TypeOfAddress === 'auto';
       };

        const clearSelectedAddress = () => {
            const autoAddress = scope.modifiedAddress.Automatic;
            autoAddress.AddressId = '';
            autoAddress.PostCode = '';
            scope.showEditManualLink = true;
        };

        scope.isManualAddress = isManualAddress;
        scope.isAutoAddress = isAutoAddress;

        scope.hasSelectedAddress = function () {
            return isValidAddress(scope.modifiedAddress);
        };

        function addressTransformer(address) {
            const newAddress = {};

            if (address.AddressMode === 'auto') {
               _.assign(newAddress, scope.modifiedAddress, scope.modifiedAddress.Automatic);
            } else {
                _.assign(newAddress, scope.modifiedAddress, scope.modifiedAddress.Manual);
                newAddress.Suburb = scope.addressStoreLocatorSearch.suburb;
                newAddress.Postcode = scope.addressStoreLocatorSearch.postcode;
                newAddress.State = scope.addressStoreLocatorSearch.state;
            }

            return newAddress;
        }

        function saveAddress(dto) {

            if (checkoutService.currentSession.isGuestSignedIn) {
                dto.IsPrimary = true;
                dto.IsForBilling = false;
            }

            if (!checkoutService.currentSession.isGuestSignedIn) {
                const guestDetails = {
                    FirstName: dto.FirstName,
                    LastName: dto.LastName,
                    CompanyName: dto.CompanyName,
                    EmailAddress: scope.currentUser.email,
                    DateOfBirth: dto.DateOfBirth,
                    MobilePhone: dto.ContactNumber,
                    TypeOfDeliveryMethod: dto.DeliveryMethod,
                    TypeOfAddress: dto.AddressMode,
                    ClickAndCollectFulfilmentStoreId: storePickerService.fulfilmentInfo.ClickAndCollectDetails.FulfilmentStoreID,
                    QasDeliveryAddressId: dto.AddressId || '',
                    DeliveryAddressStreet1: dto.Manual.Street1,
                    DeliveryAddressStreet2: dto.Manual.Street2,
                    DeliveryAddressSuburb: scope.addressStoreLocatorSearch.suburb,
                    DeliveryAddressPostcode: scope.addressStoreLocatorSearch.postcode,
                    DeliveryAddressState: scope.addressStoreLocatorSearch.state,
                    NomineeFirstName: dto.FirstName,
                    NomineeLastName: dto.LastName,
                    NomineeCompanyName: dto.CompanyName,
                    NomineePhoneNumber: dto.ContactNumber,
                    IsForBilling: true
                };
                return checkoutService.guestSignup(guestDetails, scope.isGuestTheRecipient);

            } else if (dto.AddressMode === 'auto') {
                scope.delivery.isGuestTheRecipient(scope.isGuestTheRecipient, true);
                return AddressService.save(dto);
            }

            return AddressService.saveManual(dto);

        }


        scope.saveAddress = function () {
            if (scope.addressForm.$valid && scope.isEligible === true) {
                scope.loading = true;
                const dto = addressTransformer(scope.modifiedAddress);

                saveAddress(dto).then((response) => {
                    scope.loading = false;

                    if (response.Success === false || response === false) {
                        scope.serverErrors = response.FieldErrors;
                        
                        //set field error if not getting from api response
                        if(scope.serverErrors && !Object.keys(scope.serverErrors).length && response.Message) {
                            scope.serverErrors = [{
                                FieldName: 'MobilePhone',
                                Message: response.Message
                            }];
                        } else if(AddressService.savedError) {
                            const responseStatus = AddressService.savedError.data.ResponseStatus;
                            scope.serverErrors = [{
                                FieldName: 'MobilePhone',
                                Message: responseStatus.Message
                            }];
                        } else if(checkoutService.savedError) {
                            const responseStatus = checkoutService.savedError.data.ResponseStatus;
                            scope.serverErrors = [{
                                FieldName: 'MobilePhone',
                                Message: responseStatus.Message
                            }];
                        }
                        
                        fillServerErrors.fillForm(scope.addressForm, scope.serverErrors, scope);
                        if (response.Excluded) { //no notification if excluded is true
                            $rootScope.$broadcast('guestsignup:excluded', response.Message);
                        } else {
                            BwsNotificationService.error('Address was not updated');
                        }
                    } else {
                        updateAddress();
                        BwsNotificationService.success('Address successfully added');
                        $rootScope.$broadcast('address:added');
                        scope.editMode.isAddingNewAddress = false;
                        atm.push('', guestUserCreatedMapper);
                        scope.loading = false;

                        if (storePickerService.fulfilmentInfo.FulfilmentMethod === 'Pick Up') {
                            storePickerService.getFulFilmentInfo();
                        }
                    }
                }, function (response) {
                        let serverErrors = [];
                        //set field error if not getting from api response
                        if(scope.serverErrors && !Object.keys(response.data.ResponseStatus.Errors).length) {
                            serverErrors = response.data.ResponseStatus.Errors;
                        } else {
                            serverErrors = [{
                                FieldName: 'MobilePhone',
                                Message: response.Message
                            }];
                        }
                        fillServerErrors.fillForm(scope.addressForm, serverErrors, scope);
                        scope.changeAddressValidationMessage = 'Address was not updated';
                        scope.loading = false;
                    });
                }
            };

            scope.useAutoAddress = function () {
                scope.modifiedAddress.AddressMode = 'auto';
                scope.showEditManualLink = true;
            };

            scope.clearAddress = function () {
                scope.modifiedAddress = buildAddress();
            };

            scope.$watch('editMode.isAddingNewAddress', resetAddressForm);

            scope.addManualAddress = function () {
                scope.modifiedAddress.AddressMode = 'manual';
                scope.showEditManualLink = false;
            };

            scope.showManualLink = function () {
                scope.showEditManualLink = true;
            };

            scope.addressOnType = function (searchTerm, fnCallback) {
                AddressService.addressOnType(searchTerm).then((addressList) => {
                    if (_.isFunction(fnCallback)) {
                        fnCallback();
                    }

                    if (addressList.length === 0) { // check if the user has typed a new address
                        clearSelectedAddress();
                    } else {
                        const match = _.find(addressList, (address) => {
                                return address.Postcode === scope.modifiedAddress.Automatic.PostCode;
                            });
                        if (_.isUndefined(match)) clearSelectedAddress();
                    }
                });
            };

            scope.onAddressSelect = function (lookedUpAddress) {
                if (lookedUpAddress && lookedUpAddress.Id) {
                    scope.modifiedAddress.Automatic.AddressId = lookedUpAddress.Id;
                    scope.modifiedAddress.Automatic.AddressLabel = lookedUpAddress.Text;
                    scope.modifiedAddress.Automatic.PostCode = lookedUpAddress.Postcode;
                    scope.showEditManualLink = false;
                } else {
                    clearSelectedAddress();
                    scope.showEditManualLink = false;
                }
            };

            scope.cancel = function () {
                scope.message = '';
                scope.cancelStep();
            };

            initialize();
        }
    };
}

module.exports = GuestSignupDeliveryDirective;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/guestsignupdelivery/guest-signup-delivery-directive.js
 **/